import { useFormContext } from 'react-hook-form'

import { Trades } from '@fortem-monorepo/web-sdk'

import { AccruedInterestField } from '@/pages/trading/new-trade/fields/AccruedInterestField'

export interface BondTradeFormFieldsProps {}

const BondTradeFormFields: React.FC<BondTradeFormFieldsProps> = ({}) => {
  const { watch } = useFormContext<Trades.BookTradeBody>()
  const strategyType = watch('strategy_type')
  if (strategyType !== 'FUND' && strategyType !== 'AMC') return null

  return (
    <div className={'flex items-center gap-4'}>
      <AccruedInterestField />
    </div>
  )
}

export default BondTradeFormFields
